import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/lib/SmoothScroll";
import { LangProvider } from "@/lib/lang";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";

export default function App() {
  return (
    <BrowserRouter>
      <LangProvider>
        <SmoothScroll>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Home />} />
          </Routes>
          <Toaster
            position="top-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "#0d0d10",
                border: "1px solid rgba(255,255,255,0.12)",
                color: "#f5f5f0",
                borderRadius: 0,
                fontFamily: "IBM Plex Mono, monospace",
                fontSize: 12,
                letterSpacing: "0.06em",
              },
            }}
          />
        </SmoothScroll>
      </LangProvider>
    </BrowserRouter>
  );
}
